import { RavelElement } from '../../../base/ravel-element/src/RavelElement.js';
import globalStyles from '../../../../common/global-styles.js';

export class RavelLedArray extends RavelElement {
    static get localStyles() {
        return `
        <style>
            #container {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                pointer-events: none;
            }
            #led-container {
                display: flex;
                flex-wrap: wrap;
                width: 200px; 
                gap: 10px; 
                background-color: #ffffff;
                padding: 10px 0px 10px 10px;
                box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                margin-bottom: 10px;
                pointer-events: auto;
            }

            .cell {
                width: 10px; 
                height: 10px; 
                background-color: #e0e0e0;
            }
        </style>
        `;
    }
  /* styles.css */


    static get html() { 
        return `
        <div id="container">
        <div id="led-container">
        </div>
        <div id="address"></div>
        <div id="state-mask"></div>
        </div>
        `;
    }
 
    static get observedAttributes() { 
        return [...super.baseObservedAttributes, 'address', 'rows', 'cols']; 
    }

    constructor() {
        super();
        const template = document.createElement('template');
        template.innerHTML = globalStyles
            + this.constructor.localStyles
            + this.constructor.html;
        this.attachShadow({ mode: 'open' });
        this.shadowRoot.appendChild(template.content.cloneNode(true));
        this.initialize();
    }
  
    connectedCallback() {
        this.setup();
    }
    
    disconnectedCallback() {
        this.teardown();
    }
    
    initialize() {
        this.container = this.shadowRoot.querySelector('#led-container');
        this.address = '000000';
        this.rows = 2;
        this.cols = 2;
        this.stateMask = '';
        this.stateArray = [];
        this.red = [];
        this.green = [];
        this.blue = [];
    }
  
    setup = () => {
        this.observedMessages = [`${this.address}`];
        this.subscribe(this.observedMessages);
        let container = this.shadowRoot.querySelector('#led-container');
        container.addEventListener('click', this.handleClick );
        this.addEventListener('toggle', this.handleMessage);
        let count = 0;
        for (let r = 0; r < this.rows; r++) {
            for (let c = 0; c < this.cols; c++) {
                console.log(c + this.rows * r);
                container.innerHTML += `<div id="led-${count}" class="cell" led-position="${count}" row="${r}" col="${c}"></div>`;
                if ((count % 4) === 0) {
                    this.stateMask += '0';
                }
                count++;
                this.stateArray.push(0);
                this.red.push(255);
                this.green.push(0);
                this.blue.push(0);
            }
        }
        this.ledCount = count;
        container.style.width = `${(20 * this.cols)}px`;
        this.shadowRoot.querySelector('#address').innerHTML = `${this.address}`;
        this.shadowRoot.querySelector('#state-mask').innerHTML = `${this.stateMask}`;
    }
    
    teardown = () => {
        this.unsubscribe(this.observedMessages);
    }
    
    handleClick = (evt) => {
        let index = evt.target.getAttribute('led-position');
        if (index !== null) {
            if (this.stateArray[index] === 0) {
                this.stateArray[index] = 1;
                this.shadowRoot.querySelector(`#led-${index}`).style['background-color'] = 
                    `rgb(${this.red[index]}, ${this.green[index]}, ${this.blue[index]})`;
            } else {
                this.stateArray[index] = 0;
                this.shadowRoot.querySelector(`#led-${index}`).style['background-color'] = 
                    `#e0e0e0`;
            }
            this.stateArrayToMask();
        }
    }

    handleMessage = (msg) => {
        console.log(msg);
    }

    stateArrayToMask = () => {
            // Pad the array length to make it a multiple of 4
            while (this.stateArray.length % 4 !== 0) {
                this.stateArray.unshift(0); // Add leading zeros if necessary
            }
        
            // Group bits into chunks of 4 and convert each to hexadecimal
            const hexString = this.stateArray
                .join('') // Convert array to binary string
                .match(/.{1,4}/g) // Split into groups of 4 bits
                .map(bits => parseInt(bits, 2).toString(16)) // Convert each group to hexadecimal
                .join(''); // Join the hex values together
        
            this.stateMask = hexString.toUpperCase(); 
            this.shadowRoot.querySelector('#state-mask').innerHTML = `${this.stateMask}`;
    }

    maskToStateArray = (hexString) => {
        this.stateMask = hexString;
        thisStateArray = 
            hexString.split('') // Split the hex string into individual characters
            .flatMap(hexChar => {
                const binaryString = parseInt(hexChar, 16).toString(2).padStart(4, '0'); // Convert to binary and pad to 4 bits
                return binaryString.split('').map(bit => parseInt(bit)); // Split binary string into an array of bits
            });
        console.log(this.StateArray);
        this.shadowRoot.querySelector('#state-mask').innerHTML = `${this.stateMask}`;
    }

    updateLeds = () => {
        for (let i = 0; i < this.ledCount; i++) {
            if (this.stateArray[i] === 0) {
                this.shadowRoot.querySelector(`#led-${i}`).style['background-color'] = 
                    `rgb(${this.red[i]}, ${this.green[i]}, ${this.blue[i]})`;
            } else {
                this.shadowRoot.querySelector(`#led-${i}`).style['background-color'] = 
                    `#e0e0e0`;
            }
        }
    }

    attributeChangedCallback(name, oldValue, newValue) {
        // Call the parent's attributeChangedCallback to preserve its behavior
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'address') {
            this.address = newValue;
        }
        if (name === 'rows') {
            this.rows = parseInt(newValue, 10);
        }
        if (name === 'cols') {
            this.cols = parseInt(newValue, 10);
        }
    }
}
